<!-- @format -->

<template>
  <div id="index">
    <div class="desktop-top" :class="$mq">
      <div class="desktop-top__wrapper">
        <div class="desktop-top__col">
          <img
            class="desktop-top__image"
            src="@/assets/images/top/wagner.jpg"
            alt=""
          />
          <div class="desktop-top__text">
            Motiv: Hotel Goldener Anker Bayreuth
          </div>
        </div>
        <div class="desktop-top__content">
          <!-- <div class="desktop-top__stoerer" :class="$mq">
            <img src="@/assets/images/top/stoerer_three.png" alt="" />
            <a
              href="mailto:wagner@fwem.de?subject=Wagner%20-%20Anfrage%20für%20Screenings%20"
              class="btn-top"
            ></a>
            <a
              href="downloads/Wagner_Kinotour.pdf"
              target="_blank"
              class="btn-middle"
            ></a>
            <a
              href="downloads/Wagner_Kinoliste.pdf"
              target="_blank"
              class="btn-bottom"
            ></a>
          </div> -->
          <div class="desktop-top__tt">
            <img src="@/assets/images/top/wagner_tt.png" alt="Wagner" />
          </div>
          <div class="trailer" :class="$mq">
            <div v-if="$config.youtube.display">
              <div
                @click="ytVideo"
                class="open-trailer"
                style="position: relative"
              >
                <video
                  src="@/assets/videos/sizzle.mp4"
                  loop
                  muted
                  autoplay
                ></video>
                <div class="trailer-misc">
                  <img
                    class="play-btn"
                    src="@/assets/images/youtube/play.png"
                    alt
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            class="desktop-top__kinostart"
            v-html="kinostart"
            :class="$mq"
          ></div>
          <div class="desktop-top__dvd">
            <a
              href="https://www.amazon.de/gp/video/detail/B09SSKWTTX/ref=atv_dp_share_cu_r"
              target="_blank"
              ><img src="@/assets/images/top/amazon.png" alt=""
            /></a>
            <a
              href="https://tv.apple.com/de/movie/wagner-bayreuth-und-der-rest-der-welt/umc.cmc.1f3iciwad5m9mbn5sywte6qgt?itsct=tv_box_link&itscg=30200"
              target="_blank"
              ><img src="@/assets/images/top/itunes.png" alt=""
            /></a>
            <a
              href="https://naxosdirekt.de/items/wagner-bayreuth-und-der-rest-der-welt-576854"
              target="_blank"
              ><img src="@/assets/images/top/naxos.png" alt=""
            /></a>
          </div>
          <div class="desktop-top__cast">
            <img src="@/assets/images/top/cast.png" alt="Wagner" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/plugins/event-bus.js'

export default {
  inject: ['kinostart'],
  props: {
    trailer: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ytVideo() {
      EventBus.$emit('open-yt-1')
    },
  },
}
</script>

<style lang="scss">
$width: 500px;
$height: 209px;

.desktop-top {
  $self: &;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: var(--clr-blau);

  &__wrapper {
    position: absolute;
    left: 3vw;
    right: 3vw;
    top: 3vh;
    bottom: 2vh;
    min-height: 95vh;
    display: flex;
    flex-direction: row;
    #{$self}__col {
      flex: 1 1 50%;
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    }
    #{$self}__image {
      max-height: 90%;
      width: auto;
      height: auto;
    }
    #{$self}__text {
      color: white;
      font-size: 0.6rem;
    }
    #{$self}__content {
      position: relative;
      width: 50%;
      height: 100%;
      padding: 0 4%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      #{$self}__stoerer {
        position: absolute;
        right: 0;
        top: 60px;
        width: 15%;
        &.lg {
          width: 20%;
        }
        .btn-top {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 33%;
        }
        .btn-middle {
          position: absolute;
          top: 33%;
          left: 0;
          width: 100%;
          height: 33%;
        }
        .btn-bottom {
          position: absolute;
          top: 66%;
          left: 0;
          width: 100%;
          height: 33%;
        }
      }
      #{$self}__tt {
        width: 70%;
        margin-bottom: 3%;
      }
      @media screen and (max-height: 760px) {
        #{$self}__tt {
          width: 50%;
          margin-bottom: 3%;
        }
      }
      .trailer {
        width: calc($width + 2px);
        height: calc($height + 2px);
        border: 1px solid white;
        cursor: pointer;
        video {
          width: $width;
          height: $height;
        }
        .trailer-misc {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 111;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }
        /* &.lg {
          right: 0;
          bottom: 4%;
          width: calc($width * 0.8 + 2px);
          height: calc($height * 0.6 + 2px);
          video {
            width: calc($width * 0.6);
            height: calc($height * 0.59);
          }
          .trailer-misc {
            img {
              width: 30%;
            }
          }
        } */
        &.lg {
          right: 0;
          bottom: 4%;
          width: calc($width * 0.8 + 2px);
          height: calc($height * 0.8 + 2px);
          video {
            width: calc($width * 0.8);
            height: calc($height * 0.8);
          }
          .trailer-misc {
            img {
              width: 30%;
            }
          }
        }
      }
      #{$self}__kinostart {
        background-color: var(--clr-red);
        padding: 8px 50px;
        color: white;
        font-weight: 700;
        text-transform: uppercase;
        text-align: center;
        margin-bottom: 3%;
        width: calc($width + 2px);
        font-size: 2rem;
        &.lg {
          width: calc($width * 0.8 + 2px);
          font-size: 1.4rem;
        }
        /* &.lg {
          width: calc($width * 0.6 + 2px);
          font-size: 1.4rem;
        } */
      }
      #{$self}__dvd {
        display: flex;
        margin-bottom: 20px;
        a {
          display: block;
          margin-inline: 5px;
        }
      }
    }
  }
}
</style>
